<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input v-model="searchForm.code" @keyup.enter.native="handleSearch" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="handleSearch">筛选</el-button>
            <el-button class="btn" type="primary" plain @click="exportExcel">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="产品名称" prop="PRODUCT_NAME" min-width="100px"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="剩余库存总量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="安全库存量" prop="SAFETY_STOCK"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryData();
  },
  methods: {
    // 导出
    exportExcel() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 102,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        this.exportDetailVisible = false;
        this.$message.show({ text: '导出成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    handleSearch() {
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 101,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      http.post(params).then((result) => {
        this.tableData = result[0].LIST;
        this.totalCount = result[0].TOTAL_COUNT;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/safetyStockWarning.vue